export default "__VITE_ASSET__34cd12ff__"